import styled from 'styled-components';

import { mediaBreakpoint } from '../../utils/mediaBreakpoint';

type props = {
    noBorderMobile?: boolean
}
const BorderBox = styled.div<props>`
    border: ${({ theme }) => `1px solid ${theme.Colors.Aliases.divider}`};
    padding: ${({ theme }) => theme.Spacing.spacing2x};
    ${mediaBreakpoint.down('md')} {
        ${({ noBorderMobile }) => noBorderMobile && `
            border: none;
            margin: 0;
            padding: 0;
        `}
    };
`;

export default BorderBox;
